import API from '..';
const ENTITY = 'templates';

export const addTemplatePages = (id, data) =>
    API.patch(
        `/api/v1/${ENTITY}/pages/${id}/`,
        { ...data },
        { headers: { 'Content-Type': 'application/json' } },
    );
export const bulkTemplateStatus = (data) =>
    API.put(
        `/api/v1/${ENTITY}/bulk-change-status/`,
        { ...data },
        { headers: { 'Content-Type': 'application/json' } },
    );

export const createTemplate = (data) =>
    API.post(`/api/v1/${ENTITY}/listing/`, data);

export const duplicateTemplate = (data) =>
    API.post(`/api/v1/${ENTITY}/duplicate/`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

export const filterTemplates = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
    status = 'active',
} = {}) =>
    API.get(`/api/v1/${ENTITY}/listing/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            ...(searchText ? { search: searchText } : {}),
            sort: sortBy,
            status_flag: status,
        },
    });
export const getOfferCustomTemplate = (id) =>
    API.get(`/api/v1/${ENTITY}/content/${id}/`);
export const getTemplatesCatalog = () =>
    API.get(`/api/v1/${ENTITY}/catalog/`, {
        params: {
            language: 'es-mx',
        },
    });
export const updateTemplate = (data, id) =>
    API.patch(`/api/v1/${ENTITY}/template/${id}/`, data, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
export const updateTemplateContent = (data, id) =>
    API.put(`/api/v1/${ENTITY}/content/${id}/`, { ...data });
